import {IPagedData, IPagedSearch, ISurvey, ISurveyCreate, ISurveyTable, TableStatus} from '@evencel/models';

export class GetSurvey {
    public static readonly type = '[Survey] GetSurvey';
    constructor(public id: string) {}
}

export class ActivateSurvey {
    public static readonly type = '[Survey] ActivateSurvey';
    constructor(public survey: ISurveyTable) {}
}

export class SearchSurveys {
    public static readonly type = '[Survey] SearchSurveys';
    constructor(public data: IPagedSearch) {}
}

export class CreateSurvey {
    public static readonly type = '[Survey] SaveSurvey';
    constructor(public survey: ISurveyCreate) {}
}

export class UpdateSurvey {
    public static readonly type = '[Survey] UpdateSurvey';
    constructor(public survey: ISurvey) {}
}

export class DeleteSurvey {
    public static readonly type = '[Survey] DeleteSurvey';
    constructor(public survey: ISurveyTable) {}
}

export class RestoreSurvey {
    public static readonly type = '[Survey] RestoreSurvey';
    constructor(public survey: ISurveyTable) {}
}

export class GetSurveysResponse {
    public static readonly type = '[Survey] GetSurveysResponse';
    constructor(public pagedData: IPagedData<ISurvey>, public status: TableStatus) {}
}

export class GetSurveyResponse {
    public static readonly type = '[Survey] GetSurveyResponse';
    constructor(public survey: ISurvey) {}
}
